import type { RuleListItem } from '@atlas/ui-domain'
import { toRuleListItem } from '@/adapters/rule-list-item'
import type { ApplicableRule } from '@/domain/rules.types'

/** One applicable rule for an Explore surface: the shared mapping, verbatim. */
export const toExploreRuleListItems = (rules: ApplicableRule[]): RuleListItem[] => rules.map(toRuleListItem)
